import React, { Component } from 'react';
import { Radio } from 'antd';

import IntlMessages from 'util/IntlMessages';

import { classNames, isArray, isEmpty, isNotEmpty, isObject } from 'util/utils';

class KeyToSymbol extends Component {
  state = {
    key: isObject(this.props.filter) ? Object.keys(this.props.filter).find(isNotEmpty) ?? 'in' : 'in',
  };

  static getDerivedStateFromProps(props, state) {
    if (isObject(props.filter)) {
      const key = Object.keys(props.filter).find(isNotEmpty);
      if (key !== state.key) state.key = key;
    }
    return { ...state };
  }

  handleKeyChange = (e) => {
    const key = e.target.value;
    const isCheckedIn = key === 'in';
    this.setState({ key, isCheckedIn });
    this.props.onChange({ checked: true, list: [], key });
  };
  
  render() {
    const { isCheckedIn } = this.state;
    const data = this.props.data;
  
    return (
      <div className="diamondSearchItem b-b-0">
        <div className="diamondSearchDetail width-100">
          <Radio.Group onChange={this.handleKeyChange} value={this.state.key}>
            <Radio value="in" checked={isCheckedIn}>
              <IntlMessages id="app.Contains" />
            </Radio>
            <Radio value="nin" checked={!isCheckedIn}>
              <IntlMessages id="app.Doesnotcontains" />
            </Radio>
          </Radio.Group>
          <ul className="diamondSearchList mt-10">
            {data?.map?.((key) => {
              const idList = this.props.filter?.[this.state.key] ?? [];

              const checked = (() => {
                if (!isArray(key?.id) || !isArray(idList)) return false;
                return !isEmpty(key.id.find((id) => idList.includes(id)));
              })();

              const handleClick = () => this.props.onChange({ checked, list: key.id, key: this.state.key });

              return (
                <li key={key?.id} onClick={handleClick} className={classNames([checked && `active`])}>
                  {key?.webDisplay}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default KeyToSymbol;
